import { create } from "zustand";

interface MyAgentsUiState {
  /** 当前打开「已激活详情」弹窗的 agentId，null 表示关闭 */
  activeDetailAgentId: number | null;
  /** 当前打开「未激活详情」弹窗的 agentId，null 表示关闭 */
  inactiveDetailAgentId: number | null;
  /** 当前打开「补缴 FUSD 激活」弹窗的 agentId，null 表示关闭 */
  payFusdAgentId: number | null;

  openActiveDetail: (agentId: number) => void;
  closeActiveDetail: () => void;

  openInactiveDetail: (agentId: number) => void;
  closeInactiveDetail: () => void;

  openPayFusd: (agentId: number) => void;
  closePayFusd: () => void;

  /** 离开页面时统一关闭所有弹窗 */
  resetAll: () => void;
}

export const useMyAgentsUiStore = create<MyAgentsUiState>(set => ({
  activeDetailAgentId: null,
  inactiveDetailAgentId: null,
  payFusdAgentId: null,

  openActiveDetail: agentId => set({ activeDetailAgentId: agentId }),
  closeActiveDetail: () => set({ activeDetailAgentId: null }),

  openInactiveDetail: agentId => set({ inactiveDetailAgentId: agentId }),
  closeInactiveDetail: () => set({ inactiveDetailAgentId: null }),

  openPayFusd: agentId => set({ payFusdAgentId: agentId }),
  closePayFusd: () => set({ payFusdAgentId: null }),

  resetAll: () =>
    set({
      activeDetailAgentId: null,
      inactiveDetailAgentId: null,
      payFusdAgentId: null,
    }),
}));
